import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { VARIABLE_SELECTORS } from './product-page.constants';

export function validateEmptyText(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value || '';
    return !value.trim() ? { emptyText: 'Cannot be empty' } : null;
  };
}

export function validateShippingPattern(requiredVariables: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value ?? '';
    const missingVariables = requiredVariables
      .map((variable) => (value.includes(variable) ? null : variable))
      .filter(Boolean);

    return missingVariables.length ? { missingVariables: `${missingVariables.join(', ')} must be included` } : null;
  };
}

export function validateLongDeliveryField(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    return value.hideIfLongDelivery && value.enabled && +value.hideIfLongDeliveryDaysThreshold <= 0
      ? { longDelivery: 'Number of days must be positive' }
      : null;
  };
}

export function generateShippingPattern(
  basePattern: string,
  showPrice: boolean,
  showZipcode: boolean,
  showCutoff: boolean,
): string {
  let pattern = basePattern;

  if (showPrice) {
    pattern += ` for ${VARIABLE_SELECTORS.SHIPPING_RATE}`;
  }

  if (showZipcode) {
    pattern += ` ${VARIABLE_SELECTORS.SHIPPING_ZIPCODE}`;
  }

  if (showCutoff) {
    pattern += ` order within ${VARIABLE_SELECTORS.CUTOFF_TIME}`;
  }

  return pattern;
}
